
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_conta_email',
        option: {
            key: 'id',
            label: 'email',
            value: 'id'
        },
        label: 'Conta de Email',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'text',
        field: 'destinatario',
        maxlength: 255,
        label: 'Destinatário',
        info:'Separe os emails por `;` (ponto e vírgula) para enviar a varios destinatários',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'editor',
        field: 'mensagem',
        label: 'Enviar Email com a Seguinte Mensagem',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'editor',
        field: 'pdf',
        label: 'Modelo da Proposta (em PDF)',
        rules: ['required']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/ltcat/orcamento/_form/orcamento-email.js